import React, { Component } from "react"
import { connect } from "react-redux"
import { fromJS } from "immutable"
import { actions } from "react-redux-form/immutable"
import { Confirm } from "bisu-react-modal"

import { requestUnlock, requestCancelUnlock } from "../../actions"

const withDelete = WrappedComponent =>
  connect(state => ({
    __pending: state.grade.get("requesting"),
  }))(
    class extends Component {
      constructor(props) {
        super(props)
        this.state = {
          openConfirmUnlock: false,
          openConfirmCancelUnlock: false,
          itemID: 0,
        }
      }

      _openConfirmUnlock = itemID => {
        this.setState({
          openConfirmUnlock: true,
          itemID,
        })
      }

      _openConfirmCancelUnlock = itemID => {
        this.setState({
          openConfirmCancelUnlock: true,
          itemID,
        })
      }

      _onConfirmUnlock = () => {
        const { itemID } = this.state
        const { dispatch, offeringGroupID } = this.props
        dispatch(requestUnlock(offeringGroupID, itemID)).then(res => {
          if (!res.error) {
            dispatch(actions.change("classState", fromJS(res.payload || {})))
            this.setState({
              openConfirmUnlock: false,
              itemID: 0,
            })
          }
        })
      }

      _onConfirmCancelUnlock = () => {
        const { itemID } = this.state
        const { dispatch, offeringGroupID } = this.props
        dispatch(requestCancelUnlock(offeringGroupID, itemID)).then(res => {
          if (!res.error) {
            dispatch(actions.change("classState", fromJS(res.payload || {})))
            this.setState({
              openConfirmCancelUnlock: false,
              itemID: 0,
            })
          }
        })
      }

      _renderConfirmUnlockDialog() {
        const { openConfirmUnlock } = this.state
        const { __pending } = this.props

        return (
          <Confirm
            isOpen={openConfirmUnlock}
            onCancel={() => this.setState({ openConfirmUnlock: false })}
            onConfirm={this._onConfirmUnlock}
            pending={__pending}
          >
            Are you sure you want to request to unlock this grade?
          </Confirm>
        )
      }

      _renderConfirmCancelUnlockDialog() {
        const { openConfirmCancelUnlock } = this.state
        const { __pending } = this.props

        return (
          <Confirm
            isOpen={openConfirmCancelUnlock}
            onCancel={() => this.setState({ openConfirmCancelUnlock: false })}
            onConfirm={this._onConfirmCancelUnlock}
            pending={__pending}
          >
            Are you sure you want to cancel the request to unlock this grade?
          </Confirm>
        )
      }

      render() {
        return (
          <div>
            <WrappedComponent
              openConfirmUnlock={this._openConfirmUnlock}
              openConfirmCancelUnlock={this._openConfirmCancelUnlock}
              {...this.props}
            />
            {this._renderConfirmUnlockDialog()}
            {this._renderConfirmCancelUnlockDialog()}
          </div>
        )
      }
    }
  )

export default withDelete



// WEBPACK FOOTER //
// ./src/containers/Grades/hocs/withRequests/index.js